var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 90,
    viewBox: "0 0 51 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.45503 32.6032L2.62962 35.6297L1 37.4921L1.29102 41.7408L3.03705 46.8042L10.6032 53.963L11.5926 59.4921L12.8148 59.9577L14.5609 58.3281L18.2275 60.4233L15.2011 68.6878L16.4233 71.8307L20.1482 74.3915V75.9048L21.7778 75.6138L25.9101 79.455L26.7831 83.2963L25.7937 85.3333L27.9471 89L29.5767 88.4762L31.5556 85.7989L32.6032 85.7407L38.0159 88.3016L39.0053 86.672L38.0159 85.1005L38.5397 83.0635L43.4286 81.6667L42.3227 78.6984L43.8942 77.1852L43.254 75.3228L45.1164 71.1905L44.127 70.2593L44.6508 69.0952L46.0476 69.2116L50.2963 62.1693L48.4339 55.9418L49.9471 52.3333V13.5715L48.1428 8.15876L46.3968 5.01591L46.6878 1.17464L11.4762 1L14.0952 3.67724L14.3863 5.53969L17.7619 7.51856L17.1799 12.2328L15.6085 13.7461L15.7249 15.9577L11.418 17.9947L6.58731 18.926L5.7725 22.0688L7.80953 24.3386L7.92594 26.4921L5.9471 28.4127L6.0053 30.6243L2.45503 32.6032Z",
    fill: "#273137",
    fillOpacity: 0.1,
    stroke: "#273137",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIl);
export default __webpack_public_path__ + "static/media/IL.88d555240caba1dd1781162be062979a.svg";
export { ForwardRef as ReactComponent };